import { useMutationHook, useQueryHook } from "@/hooks"
import {
  ReadLatestNotificationResponse,
  ReadNoticeListParams,
  ReadUnreadNoticeCountResponse,
} from "@/types/notice"
import {
  CreateNotificationReadHistory,
  readLatestNotification,
  readNotifications,
  readUnreadNotificationCount,
} from "@/app/api/notice"

export const useNotificationsQuery = (params: ReadNoticeListParams, additionalKey?: string[]) => {
  return useQueryHook({
    queryKey: ["readNotifications", ...(additionalKey || [])],
    queryFn: () => readNotifications(params),
  })
}

export const useLatestNotificationQuery = (language: string) => {
  return useQueryHook<ReadLatestNotificationResponse, { language: string }>({
    queryKey: ["readLatestNotification"],
    queryFn: () => readLatestNotification(language),
  })
}

export const useUnreadNotificationCountQuery = () => {
  return useQueryHook<ReadUnreadNoticeCountResponse, unknown>({
    queryKey: ["readUnreadNotificationCount"],
    queryFn: () => readUnreadNotificationCount(),
  })
}

export const useCreateNotificationReadHistoryMutation = () => {
  return useMutationHook(CreateNotificationReadHistory, [
    "readUnreadNotificationCount",
    "readNotifications",
  ])
}
